import { call, put, takeLatest } from "redux-saga/effects";
import { PettyCashierOverallCostAction } from "../../actions";
import * as types from "../../actions/actionTypes";
import * as overallCostApi from "../../api/overallCost/pettyCashierOverallCost";
import { GetFilter } from "../../hocs/costClassificationReport/components/filter/tools";
import {SetMessage} from "../../assets/errorMessages";

export function* pettyCashierWatcherOverallCost() {
  yield takeLatest(types.PETTY_CASHIER_GET_OVERALL_COST_REQUEST, worker);
}

async function fetchList(separation_type, pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return overallCostApi.getList(page_number, GetFilter());
}

function* worker(action) {
  try {
    const response = yield call(
      fetchList,
      action.separation_type,
      action.pageNumber
    );
    yield put(PettyCashierOverallCostAction.getSuccess(response.data));
  } catch (error) {
    // dispatch a failure action to the store with the error
    const message = SetMessage(error);
    yield put(PettyCashierOverallCostAction.getFailure(message));
  }
}
